/**
 * The widget's top buttons — Help, the language, My account — as solid pills in the
 * salon's colour with its text colour (--primary-foreground: dark on a light colour,
 * white on a dark one; boona app/services/widget_appearance.text_color_for).
 *
 * They used to be a 10% tint with the colour itself as the text: fine for pink or
 * blue, unreadable for a light colour — КреатиFF's #FFCB00 gave yellow on near-white,
 * contrast 1.45 (2026-10-24). Solid, as YClients draws them (owner's pick, variant B).
 * Solid also stands out over a header photo, so there is one style with or without it.
 */
export const TOP_PILL = "bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm";
